import { render } from "./ModalFiltroCategorias.vue?vue&type=template&id=91a4d546&scoped=true"
import script from "./ModalFiltroCategorias.vue?vue&type=script&lang=js"
export * from "./ModalFiltroCategorias.vue?vue&type=script&lang=js"

import "./ModalFiltroCategorias.vue?vue&type=style&index=0&id=91a4d546&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91a4d546"]])

export default __exports__